import { render, staticRenderFns } from "./ProjectPagePhases.vue?vue&type=template&id=ffe69f34&scoped=true"
import script from "./ProjectPagePhases.vue?vue&type=script&lang=js"
export * from "./ProjectPagePhases.vue?vue&type=script&lang=js"
import style0 from "./ProjectPagePhases.vue?vue&type=style&index=0&id=ffe69f34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe69f34",
  null
  
)

export default component.exports